const FIRST_SEASON = 2019;
const AUGUST_MONTH = 7;

// La saison s'ouvre au mois d'août : de janvier à juillet on est encore sur la saison précédente.
const getCurrentSeason = (date = new Date()) =>
  date.getFullYear() - (date.getMonth() < AUGUST_MONTH ? 1 : 0);

export const AVAILABLE_SEASONS = Array.from(
  {length: getCurrentSeason() - FIRST_SEASON + 1},
  (_, index) => getCurrentSeason() - index,
);



// WEBPACK FOOTER //
// ./src/types/common.ts